import '@angular/compiler';
import 'core-js/proposals/reflect-metadata';
import 'zone.js';
import '@angular/localize/init'

require('../manifest.webapp');
